import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CostProfile, Identifiable, Resource } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  assignCostProfileToResource(
    data: Boundaries["assignCostProfileToResource"]["request"],
  ): void;
}

function useAssignCostProfileToResource(
  costProfile: Identifiable<CostProfile>,
  resource: Identifiable<Resource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isAssignCostProfileToResourceRequestPending(
        costProfile,
        resource,
      ),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isAssignCostProfileToResourceRequestSuccess(
        costProfile,
        resource,
      ),
    ),
    isRequestFailure: useSelector(() =>
      selector.isAssignCostProfileToResourceRequestFailure(
        costProfile,
        resource,
      ),
    ),
    assignCostProfileToResource: core.assignCostProfileToResource,
  };
}

export { useAssignCostProfileToResource };
